import { set } from 'cerebral/operators'

import checkIsAdmin from '../actions/checkIsAdmin.js'
import getUsers from '../actions/getUsers.js'
import isShouldGetUsers from '../actions/isShouldGetUsers.js'
import setUsers from '../actions/setUsers.js'

export default [
  checkIsAdmin,
  {
    true: [
      set('state:client.forms.showSnackbar', false),
      isShouldGetUsers,
      {
        true: [
          getUsers,
          {
            success: [
              setUsers,
              set('state:users.currentView', 'unapproved'),
              set('state:client.currentPage', 'users/unapproved')
            ],
            error: []
          }
        ],
        false: [
          set('state:users.currentView', 'unapproved'),
          set('state:client.currentPage', 'users/unapproved')
        ]
      }
    ],
    false: [set('state:client.currentPage', 'login')]
  }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/getUnapprovedUsers.js